import { Component } from '@angular/core';
import {SpinnerService} from "../../services/spinner.service";

@Component({
    selector: 'app-spinner',
    template: `
  <div class="overlay" *ngIf="isLoading$ | async">
    <div>
      <div class="loader">
        <div class="loader__figure"></div>
        <p class="loader__label">Maintenance Assignation</p>
      </div>
    </div>
  </div>`,
    standalone: false
})
export class SpinnerComponent {
  isLoading$ = this.spinnerService.isLoading$;

  constructor(private spinnerService: SpinnerService) { }
}
